module.exports = __webpack_public_path__ + "img/ic24FootActive.36a36110.svg";